const locale = {
  'c.ApplyAccount.title': 'اطلب فتح حساب',

  'c.ApplyAccount.label.countryCode': 'البلد',
  'c.ApplyAccount.label.companyName': 'اسم شركتك',
  'c.ApplyAccount.label.userName': 'اسمك',
  'c.ApplyAccount.label.contactInformation': 'رقم هاتفك أو عنوان بريدك الإلكتروني',
  'c.ApplyAccount.label.remark': 'ما هي المشاكل التي تريد حلها من خلال casschoice؟',

  'c.ApplyAccount.placeholder.pleaseSelect': 'الرجاء تحديد',
  'c.ApplyAccount.placeholder.pleaseEnter': 'الرجاء إدخال',
  'c.ApplyAccount.placeholder.contactInformation': 'الرجاء إدخال عنوان بريدك الإلكتروني أو واتسابك',

  'c.ApplyAccount.button.submit': 'التسجيل',
  'c.ApplyAccount.text.disclaimerText': 'لقد قرأت وافقت على {serviceAgreement} و {privacyPolicy}',
  'c.ApplyAccount.text.agreeTextMessage': 'أنا أوافق على تلقي إشعارات رسائل نصية',
  'c.ApplyAccount.text.notice':
    'سنقوم بمعالجة طلبك خلال 3 أيام عمل من تاريخ الاستلام وسنتواصل معك عبر البريد الإلكتروني أو واتساب. يرجى التحقق من رسائلك.',

  'c.ApplyAccount.disclaimerText.error': 'يرجى قراءة الاتفاقية وافق عليها أولاً.',
  'c.ApplyAccount.agreeTextMessage.error': 'يرجى الموافقة على تلقي إشعارات رسائل نصية أولاً.',

  'c.ApplyAccount.request.loading': 'جاري الإرسال...',
  'c.ApplyAccount.request.success':
    'تم إرسال الطلب بنجاح، وسنقوم بتنفيذ طلب التسجيل الخاص بك في غضون 3 أيام عمل',
  'c.ApplyAccount.request.error': 'فشل الإرسال! الرجاء المحاولة مرة أخرى في وقت لاحق.',
};
export default locale;
